/* src/app/modules/shared/components/column/column-review-score/column-grading-results.component.scss */
app-column-grading-results {
  display: contents;
}
/*# sourceMappingURL=column-grading-results.component.css.map */
